import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import FiltersContainer from "../Common/Calendar/FiltersContainer/FiltersContainer";
import Select from "../Common/FormElements/Select/Select";
import Button from "../Common/FormElements/Button/Button";
import TextInput from "../Common/FormElements/TextInput/TextInput";
import CalendarInput from "../Common/FormElements/CalendarInput/CalendarInput";
import moment from "moment";
import { MultiSelect } from "primereact/multiselect";
import { isDefined } from "../../Utils";

const DataTableFilters = ({
  title = "",
  titleClassName,
  newItemTitle = "",
  elements,
  selectOptions,
  handleSearch,
  addNewItem,
  setFilters,
  total,
}) => {
  const { t } = useTranslation("common");
  const [showFilters, setShowFilters] = useState(false);
  const [formData, setFormData] = useState({});
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <div className="alignH my-3 justify-content-between gap-5">
        <span
          className={
            titleClassName ? titleClassName : "text-blue bold f22 quickSand"
          }
        >
          {t(`${title}`)}
          {isDefined(total) ? ` (${total})` : ""}
        </span>
        <div className="d-flex align-items-center gap-3 justify-content-end flex-grow-1">
          {addNewItem && (
            <Button className="" onClick={addNewItem}>
              {t(`${newItemTitle}`)}
            </Button>
          )}
          <div className="w-100 max-w-500px">
            <TextInput
              placeholder={t("Search")}
              width="100%"
              callback={handleSearch}
            />
          </div>
          {setFilters && (
            <Button
              Icon={() => <i className="bi bi-funnel fa-lg" />}
              onClick={() => setShowFilters((prev) => !prev)}
              variant={showFilters && "outline"}
            >
              {t("Filters")}
            </Button>
          )}
        </div>
      </div>
      {showFilters && (
        <FiltersContainer className="my-4">
          <div className="row g-3 flex-wrap">
            {elements?.map((el) => {
              if (el.type === "select") {
                return (
                  <div className="col-3" key={el.name}>
                    <label className="f16 text-softBlack mb-2 sBold">
                      {t(`${el.label}`)}
                    </label>
                    <Select
                      {...el}
                      value={formData[el.name]}
                      options={selectOptions[el.name] ?? []}
                      placeholder={t(`${el.placeholder}`)}
                      callback={handleFilterChange}
                    />
                  </div>
                );
              } else if (el.type === "multiselect") {
                return (
                  <div className="col-3">
                    <label className="f16 text-softBlack mb-2 sBold">
                      {t(`${el.label}`)}
                    </label>
                    <MultiSelect
                      {...el}
                      value={formData[el.name]}
                      options={selectOptions[el.name] ?? []}
                      placeholder={t(`${el.placeholder}`)}
                      onChange={handleFilterChange}
                      className="h-40px w-100"
                    />
                  </div>
                );
              } else if (el.type === "text") {
                return (
                  <div className="col-3" key={el.name}>
                    <label className="f16 text-softBlack mb-2 sBold">
                      {t(`${el.label}`)}
                    </label>
                    <TextInput
                      {...el}
                      placeholder={t(`${el.placeholder}`)}
                      value={formData[el.name] ?? ""}
                      callback={handleFilterChange}
                    />
                  </div>
                );
              } else if (el.type === "date") {
                return (
                  <div className="col-3">
                    <label className="f16 text-softBlack mb-2 sBold">
                      {t(`${el.label}`)}
                    </label>

                    <CalendarInput
                      {...el}
                      placeholder={t(`${el.placeholder}`)}
                      className="w100"
                      value={
                        formData[el.name]
                          ? moment(formData[el.name]).utc(true).toDate()
                          : null
                      }
                      callback={handleFilterChange}
                    />
                  </div>
                );
              }
              return null;
            })}
          </div>
          <Button
            className="filterSubmitBtn mt-4 ms-auto"
            onClick={() => setFilters(formData)}
          >
            {t("Filter")}
          </Button>
        </FiltersContainer>
      )}
    </>
  );
};

export default DataTableFilters;
